import { Edit3, Image as ImageIcon, Trash2 } from "lucide-react";
import { Badge } from "../ui/badge";
import { AREA_BY_ID, RESTAURANT_BY_ID } from "../../constants";

export default function CatalogProductCard({ product, supplier, editable, isMain, onEdit, onAskDelete }) {
  return (
    <div className="bg-white rounded-xl border border-[#E6E0D4] overflow-hidden hover:border-[#0B1F3A]/25 transition-colors" data-testid={`product-card-${product.id}`}>
      <div className="aspect-[16/10] bg-white overflow-hidden relative p-3">
        {product.image ? (
          <img
            src={product.image}
            alt={product.name}
            className="h-full w-full object-contain"
            loading="lazy"
            onError={(e) => {
              e.currentTarget.style.display = "none";
            }}
          />
        ) : (
          <div className="h-full w-full flex items-center justify-center text-[#0B1F3A]/20">
            <ImageIcon size={28} />
          </div>
        )}
        <div className="absolute top-2 left-2">
          <Badge
            variant="outline"
            className="bg-white/90 backdrop-blur border-[#E6E0D4] text-[#0B1F3A]/70 text-[10px] tracking-eyebrow uppercase"
          >
            {product.category}
          </Badge>
        </div>
        {!product.active && (
          <div className="absolute top-2 right-2">
            <Badge
              variant="outline"
              className="bg-white/90 border-red-300 text-red-600 text-[10px] tracking-eyebrow uppercase"
            >
              Inactive
            </Badge>
          </div>
        )}
      </div>
      <div className="p-3">
        <p className="text-[14px] font-medium text-[#0B1F3A] leading-snug line-clamp-2 min-h-[2.5em]">
          {product.name}
        </p>
        <p className="text-xs text-[#0B1F3A]/60 mt-1 truncate">
          {supplier?.name || "—"}{" "}
          {supplier && (
            <span className={supplier.type === "delivered" ? "text-[#2B7A6B]" : "text-[#C4552B]"}>
              · {supplier.type === "delivered" ? "Delivered" : "Direct"}
            </span>
          )}
        </p>
        <div className="mt-1 flex flex-wrap gap-1">
          {(product.assignedRestaurants || []).map((rid) => (
            <span
              key={rid}
              className="text-[10px] bg-[#F3EFE7] border border-[#E6E0D4] rounded-full px-2 py-0.5 text-[#0B1F3A]/70"
            >
              {RESTAURANT_BY_ID[rid]?.name}
            </span>
          ))}
          {(product.assignedAreas || []).map((aid) => (
            <span
              key={aid}
              className="text-[10px] bg-white border border-[#E6E0D4] rounded-full px-2 py-0.5 text-[#0B1F3A]/70"
            >
              {AREA_BY_ID[aid]?.name}
            </span>
          ))}
        </div>
        <div className="mt-2 flex items-center justify-between">
          <span className="text-[11px] text-[#0B1F3A]/55">Par {product.par} {product.unit}</span>
          <div className="flex gap-1">
            <button
              disabled={!editable}
              onClick={onEdit}
              className="h-8 w-8 rounded-md hover:bg-[#F3EFE7] flex items-center justify-center text-[#0B1F3A]/70 hover:text-[#0B1F3A] transition-colors disabled:opacity-30 disabled:cursor-not-allowed"
              title="Edit"
              data-testid={`product-edit-${product.id}`}
            >
              <Edit3 size={14} />
            </button>
            {isMain && (
              <button
                onClick={onAskDelete}
                className="h-8 w-8 rounded-md hover:bg-red-50 flex items-center justify-center text-[#0B1F3A]/60 hover:text-red-600 transition-colors"
                title="Delete"
                data-testid={`product-delete-${product.id}`}
              >
                <Trash2 size={14} />
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
